import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
  formContainer: {
      display: 'flex',
      flexDirection: 'row',
  },
  formCol: {
    width: '50%',
    padding: '0 10px'
  },
  label: {
    display: 'block',
    fontSize: '16px',
    fontWeight: '500',
    paddingBottom: '8px',
    marginBottom: '0'
  },
  labelSelect: {
    width: '100%',
    marginBottom: '0',
    fontWeight: '500'
  },
  select: {
    marginBottom: '20px'
  },
  submitWrapper: {
    textAlign: 'center',
    marginTop: '20px',
    marginBottom: '40px'
  },
  selectStyle: {
    border: '1px solid #F4F4F4',
    marginBottom: '20px',
    display: 'block',
    backgroundColor: '#F4F4F4',
    height: '36px',
    width: 'calc(100% - 20px)',
    fontSize: '16px',
    borderRadius: '0',
    padding: '0 10px',
    color: '#7092A9'
  },
  inputStyle: {
    border: '1px solid #F4F4F4',
    marginBottom: '20px',
    display: 'block',
    backgroundColor: '#F4F4F4',
    height: '36px',
    width: 'calc(100% - 20px)',
    fontSize: '16px',
    borderRadius: '0',
    padding: '0 10px',
    color: '#7092A9',
    '::placeholder': {
      color: '#7092A9'
    }
  },
  errorMessage: {
    color: '#C01236',
    fontSize: '17px',
    textAlign: 'center'
  },
  error: {
    border: '1px solid #C01236'
  }
});

export default styles;
